<div>
  <mat-icon>lock</mat-icon>
  <p>
    You do not have the necessary permission to access this resource.
    <br />
    If you require assistance please contact the support desk.
  </p>
</div>
